import React from 'react';

export default function Refitting() {
  return (
    <div className="mx-3">
      <div className="bg-white border p-3 mx-3">
        <p>TBA</p>
      </div>
    </div>
  );
}
